import * as React from 'react';
import AuthContext from './AuthContext.js';
import TokenObject from './TokenObject.js';
import { authReducer } from './utils/reducers.js';

/**
 * AuthProvider - The Authentication Context Provider
 *
 * @param children
 * @param authStorageName
 * @param cookieDomain
 * @param cookieSecure
 *
 * @return Functional Component
 */
var AuthProvider = function (_a) {
    var children = _a.children, authType = _a.authType, authName = _a.authName, cookieDomain = _a.cookieDomain, cookieSecure = _a.cookieSecure;
    if (authType === 'cookie') {
        if (!cookieDomain) {
            throw new Error('Auth Provider Error');
        }
    }
    var tokenObject = new TokenObject(authName, authType, cookieDomain, cookieSecure);
    var _b = React.useReducer(authReducer, tokenObject.initialToken()), authState = _b[0], dispatch = _b[1];

    React.useEffect(function () {
        tokenObject.syncTokens(authState);
    }, [authState]);
    return (React.createElement(AuthContext.Provider, { value: { authState: authState, dispatch: dispatch } }, children));
};

export default AuthProvider;